import { Component, OnInit, Input } from '@angular/core';
import { CmsService } from 'src/_service/CmsService';
import { Lifestyle } from '../../_model/recipe';
import { LifestyleService } from '../../_service/LifestyleService';
import { LifestylecardComponent } from '../lifestylecard/lifestylecard.component';

@Component({
    selector: 'app-cms-lifestyle-cards',
    templateUrl: './cms-lifestyle-cards.component.html',
    imports: [LifestylecardComponent]
})
export class CmsLifestyleCardsComponent implements OnInit {

  @Input() card: any;
  
  all_lifestyles: Lifestyle[] = [];

  selectedLifestyle: Lifestyle;

  showLimit = 6;
  showAll = false;
  selected_lifestyles = [];
  
  constructor(
    private _cmsService: CmsService,
    private _lifestyleService: LifestyleService
    ) {
  }


  ngOnInit() {
    if( this.card.max_visible ){
      this.showLimit = Number(this.card.max_visible);
    }    
    this._lifestyleService.getLifestyleList().subscribe(
      result => {
        result = result.sort((a, b) =>  a.sequenceid - b.sequenceid)
        this.all_lifestyles = result;
        if( this.card.lifestyles ){
          this.selected_lifestyles = this.card.lifestyles.map(ls_id => this.all_lifestyles.find(ls => ls.id == ls_id)); 
        } else {
          this.selected_lifestyles = this.all_lifestyles;
        }
      }, error => {
        console.log(error);
      }
    );
  }

  get_alt(field) {
    return this._cmsService.get_alt(field);
  }

  get_sanitized_url(url) {
    return this._cmsService.get_sanitized_url(url);
  }

  get_src(field, contain, height?, width?) {
    return this._cmsService.get_src(field, contain, height, width);
}

  get_classes(card) {
    return this._cmsService.get_classes(card);
  }

}



